import { Navigate } from "react-router-dom"

import { FeatureFlag, isFeatureEnabled } from "store/featureFlagsSlice"
import { useAppSelector } from "store/hooks"

import { ContentWrapper } from "components/common/ContentWrapper"

import { AlertRulesTable } from "./AlertRulesTable"

const AlertRulesPage = () => {
  const isAlertRulesEnabled = useAppSelector(isFeatureEnabled(FeatureFlag.AlertRules))

  if (!isAlertRulesEnabled) {
    return <Navigate to="/monitoring" replace />
  }

  return (
    <ContentWrapper title="Alert Rules">
      <AlertRulesTable editConfirmButtonText="Update" />
    </ContentWrapper>
  )
}

export default AlertRulesPage
